import { NavigationGuardNext, Route, RouteConfig } from 'vue-router'
import { routes } from '@/router/index'
import store from '@/store'
import Config from '@/config/config'
import { PermissionPageManager } from '@/api/permissions/pages'
import { permissions } from '@/api/permissions/permissions'

function findPathByURL(url: string) {
  for (const route of routes) {
    const routerPages: RouteConfig[] | undefined = route.children
    if (routerPages) {
      const found = routerPages.find((r) => r.path === url)
      if (found) {
        return found
      }
    }
  }
  return null
}

export const beforeEachRoute = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) => {
  // Change NavBar title
  store.commit(
    'navBarTitle/setTitleFromRoute',
    { width: window?.innerWidth ?? Config.defaultWidth, to: to },
    { root: true }
  )

  const isAuthed = store.getters['user/isAuthenticated']
  const roles = store.getters['user/userRoles']

  const abilities = PermissionPageManager.pages()
  const pageName: string = to.name ? to.name : ''
  const canViewThisPage = abilities.can(permissions.viewPage, pageName)

  // Change redirect URL
  routes[0].redirect = isAuthed
    ? findPathByURL(Config.routing.homePage.path)!.path
    : findPathByURL(Config.routing.authPage.path)!.path

  // незванный гость из etuID
  if (
    roles.length <= 0 &&
    !canViewThisPage &&
    to.path != Config.routing.enrollPage.path
  ) {
    return next(findPathByURL(Config.routing.enrollPage.path)!.path)
  }

  // if it's redirect, do redirect
  if (routes.find((r) => r.redirect === to.path)) {
    return next()
  }

  if (!isAuthed) {
    // if this page without auth, redirect to page to.path
    if (canViewThisPage) {
      return next()
    } else {
      return next(routes[0].redirect)
    }
  }

  if (isAuthed && !canViewThisPage && to.path !== '/error') {
    const user = store.getters['user/currentUser']
    const name =
      user && user.initials ? user.initials : 'Неизвестный пользователь'
    store.dispatch('toast/pushToast', {
      title: 'Авторизация',
      message: `Выполнена авторизация в системе от имени <b>${name}</b>. Данный пользователь не имеет прав на просмотр страницы.`,
    })
  }

  if (!canViewThisPage) {
    return next('/error')
  }

  next()
}
